import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { ContractService } from './../base/contract';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { BlockContract } from '../../model/block-contract';
import { BlockRentalObject } from '../../model/block-rental-object';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { LeaseRow } from '../../model/lease-row';
import { Contract } from '../../model/contract';
import { LocalDate } from '../../../core/model/local-date';

@Injectable()
export class BlockContractService extends ContractService<BlockContract> {
  constructor(
    httpClient: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(httpClient, config, messageService, BlockContract, progressBar, 'block-agreement', 'SamlingsKontrakt.xlsx');
  }

  getRentRowsByArticle(leaseStartDate: Date, rentalObjectIds: string[]): Observable<LeaseRow[]> {
    this.progressBar.start();
    let path = `${this.endpoint}/lease-row-templates-sum`;
    return this.client.post<LeaseRow[]>(path, { startDate: leaseStartDate, rentalObjectIds }).pipe(finalize(() => this.progressBar.stop()));
  }

  getRentRows(rentalObjectIds: string[]): Observable<LeaseRow[]> {
    this.progressBar.start();
    let path = `${this.endpoint}/lease-row-templates`;
    return this.client.post<LeaseRow[]>(path, rentalObjectIds).pipe(finalize(() => this.progressBar.stop()));
  }

  getObjectSelection(
    propertyId: string,
    leaseAgreementId: string,
    contractFromDate?: LocalDate
  ): Observable<{
    dwellings: BlockRentalObject[];
    premises: BlockRentalObject[];
    parkings: BlockRentalObject[];
    otherObjects: BlockRentalObject[];
  }> {
    this.progressBar.start();
    const normalizedFromDate = LocalDate.fromDate(contractFromDate);
    const fromDateQuery = normalizedFromDate?.hasValue() ? `?contractFromDate=${normalizedFromDate.toISOString()}` : '';
    let path = `${this.endpoint}/object-selection/${propertyId}/${leaseAgreementId ? leaseAgreementId : ''}${fromDateQuery}`;
    return this.client.get<any>(path).pipe(
      map(result => {
        return {
          dwellings: result.dwellings.map(item => Object.assign(new BlockRentalObject(), item)),
          premises: result.premises.map(item => Object.assign(new BlockRentalObject(), item)),
          parkings: result.parkings.map(item => Object.assign(new BlockRentalObject(), item)),
          otherObjects: result.otherObjects.map(item => Object.assign(new BlockRentalObject(), item)),
        };
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  retrieveUpdatedLeaseAgreementBlock(contract: Contract): Observable<any> {
    return this.client.patch(`${this.endpoint}/get-updated-block`, contract);
  }
}
